import React from 'react';
import { LOADING_MESSAGE, LoadingIndicator, Placeholder } from '@fupa/fupa-uikit';
import CompetitionMatchdayList from 'app/components/matchCalendar/CompetitionMatchdayList';
import { StreamPlaceholder } from 'app/styles/stream';
export default function DistrictCompetitionMatchdays(_ref) {
  let {
    competitionMatchdays,
    isFetching,
    districtName,
    isError
  } = _ref;
  if (!competitionMatchdays.length && !isFetching && !isError) {
    return /*#__PURE__*/React.createElement(Placeholder, null, "Keine Spiele im Kreis ", districtName, ".");
  }
  if (!competitionMatchdays.length && isFetching) {
    return /*#__PURE__*/React.createElement(LoadingIndicator, {
      bgColor: true,
      message: LOADING_MESSAGE.loadingMatches
    });
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(CompetitionMatchdayList, {
    data: competitionMatchdays,
    "data-sentry-element": "CompetitionMatchdayList",
    "data-sentry-source-file": "DistrictCompetitionMatchdays.tsx"
  }), isFetching ? /*#__PURE__*/React.createElement(LoadingIndicator, {
    bgColor: true,
    message: LOADING_MESSAGE.loadingMatches
  }) : null, isError ? /*#__PURE__*/React.createElement(StreamPlaceholder, null, "Beim Laden der Spiele aus dem Kreis ", districtName, " ist ein Fehler aufgetreten.") : null);
}